import { withInstall } from '@ideaz/utils'
import Crud from './src/Crud'

export default withInstall(Crud)
export * from './src/props'
